import ListaRegimes from "./ListaRegimes";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function RegimeForm({ styles }) {

    return(
        <AlertDialogOnClose nome={"Regime"} placeholder={"Insira o nome do regime"}>
            <ListaRegimes />
        </AlertDialogOnClose>
    )
} 